import React from "react";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ShowSidebar from "../Sidebar/ShowSidebar";
import { Helmet } from "react-helmet";
import {
  getShowAwards,
  getShowDetailPage,
} from "../../../utils/api/helpers/show";
import { S3URL } from "../../../data/globalConstants";
import ShowAwardsList from "./components/ShowAwardsList";
import { useActiveGenre } from "../../../utils/Genre/activeGenreState";
import { getGuildHomePath } from "../../../utils/Guild/guildUtils";

gsap.registerPlugin(ScrollTrigger);

export default function ShowAwardsDetail() {
  const { genreSlug, showSlug } = useParams();
  const navigate = useNavigate();
  const [activeGenre] = useActiveGenre();

  const [showData, setShowData] = useState(null);
  const [showAwards, setShowAwards] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!genreSlug || !showSlug) return;

    let isMounted = true;

    const loadShow = async () => {
      setIsLoading(true);

      try {
        const res = await getShowDetailPage(genreSlug, showSlug);
        const show = res?.data;

        const isShowDisabled = !show || Number(show.visible) === 0;

        if (isShowDisabled) {
          navigate(getGuildHomePath(), { replace: true });
          return;
        }

        if (isMounted) {
          setShowData(show);
        }
      } catch (error) {
        console.error("Unable to load show:", error);

        if (isMounted) {
          navigate(getGuildHomePath(), { replace: true });
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    loadShow();

    return () => {
      isMounted = false;
    };
  }, [genreSlug, showSlug, navigate]);

  useEffect(() => {
    if (!genreSlug || !showSlug) return;

    getShowAwards(genreSlug, showSlug)
      .then((res) => {
        if (res?.data?.competitions?.length > 0) {
          setShowAwards(res.data.competitions);
        }
      })
      .catch((error) => {
        console.error("Unable to load show awards:", error);
      });
  }, [genreSlug, showSlug]);

  if (isLoading) {
    return (
      <div className="loading-message-container">
        <div className="loading-message">
          <img
            src="/img/ico/spinner.gif"
            alt="Loading..."
            className="loading-spinner"
          />
        </div>
      </div>
    );
  }

  return (
    <div>
      <Helmet>
        <title>{`${showData?.title} | Netflix Series FYC`}</title>
        <meta name="description" content={`${showData?.title}`} />
      </Helmet>

      <div
        className="width-ctrl show-page-container"
        style={{ paddingTop: "120px" }}
      >
        <div className="show-page-inner">
          <div className="show-left-column">
            <ShowSidebar
              showData={showData}
              genreSlug={genreSlug}
              showSlug={showSlug}
              displayAwards={false}
            />
          </div>

          <div className="show-right-column">
            <div className="show-main-content">
              <div className="show-awards-page-content">
                {/* <div
                  className="award-page-title"
                  style={{ color: activeGenre?.theme?.colors?.light?.hex }}
                >
                  For Your Consideration
                </div> */}

                <ShowAwardsList showAwards={showAwards} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="show-page-background">
        {showData?.backgroundImage && (
          <img
            src={S3URL + showData.backgroundImage}
            fetchPriority="high"
            alt={showData?.title}
            className="show-masked-image blurred-image"
          />
        )}
      </div>
    </div>
  );
}
